import { render, staticRenderFns } from "./appFooterPhone.vue?vue&type=template&id=35ef3fb1&scoped=true"
import script from "./appFooterPhone.vue?vue&type=script&lang=js"
export * from "./appFooterPhone.vue?vue&type=script&lang=js"
import style0 from "./appFooterPhone.vue?vue&type=style&index=0&id=35ef3fb1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ef3fb1",
  null
  
)

export default component.exports